<template>
  <!-- 看板 -->
  <div class="NoPermission">
    <div class="top_center">
      <div>
        <div class="nologins">
          <div class="nologins_title">
            <div class="nologins_title_icon">
            </div>
            <div class="nologins_title_text center">
              尚未开通权限，前往购买套餐。
              <div class="flex mt20 mb20 alcen">
                <p class="yes center cursor ba6e coff ru5 sz14" @click="gopage">是</p>
                <p class="no center cursor sz14 ru5 co6e" @click="retrns">否</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
    gopage() {
      this.$router.push('./package')
    },
    retrns() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.NoPermission {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;

  .nologins {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5, #000);

    .nologins_title {
      width: 400px;
      // height: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      margin-left: -200px;
      background: #fff;
      border-radius: 15px;
      padding: 20px;
    }

    .nologins_title_icon {
      width: 100%;
      text-align: right;
      font-size: 26px;
      padding-right: 10px;

      i {
        color: #000;
      }
    }

    .nologins_title_img {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      margin-top: 40px;

      img {
        width: 200px;
        height: 200px;
        display: inline-block;
        margin: 0 auto;
      }
    }

    .nologins_title_text {
      width: 100%;
      margin-top: 20px;
      font-size: 22px;

      div {
        justify-content: space-around;
      }

      .yes {
        width: 100px;
        height: 40px;
        line-height: 40px;
      }

      .no {
        width: 100px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #be3c6e;
      }
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}</style>
<style lang="less"></style>